import React, { useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface MaterialCarouselProps {
  images: string[];
}
export function MaterialCarousel({
  images
}: MaterialCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  const shouldRenderImage = (index: number) => {
    const diff = Math.abs(index - currentIndex);
    return diff <= 1 || diff === images.length - 1;
  };
  return <div className="relative" data-id="element-183">
      {/* Main Image Container - 3:4 aspect ratio for document pages */}
      <div className="relative bg-white rounded-2xl overflow-hidden max-w-[340px] mx-auto shadow-lg border border-gray-200" data-id="element-184">
        <div className="relative w-full" style={{
        aspectRatio: '3 / 4'
      }} data-id="element-185">
          {images.map((image, index) => <div key={index} className={`absolute inset-0 ${index === currentIndex ? 'block' : 'hidden'}`} data-id="element-186">
              {shouldRenderImage(index) && <img src={image} alt={`Aperçu du matériel - Page ${index + 1}`} className="w-full h-full object-contain block" loading={index === 0 ? 'eager' : 'lazy'} decoding="async" fetchPriority={index === 0 ? 'high' : 'low'} data-id="element-187" />}
            </div>)}
        </div>

        {/* Navigation Arrows */}
        <button onClick={goToPrevious} className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 md:p-3 rounded-full shadow-lg transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-yellow-400" aria-label="Image précédente" data-id="element-188">
          <ChevronLeft className="h-5 w-5 md:h-6 md:w-6" data-id="element-189" />
        </button>
        <button onClick={goToNext} className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 md:p-3 rounded-full shadow-lg transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-yellow-400" aria-label="Image suivante" data-id="element-190">
          <ChevronRight className="h-5 w-5 md:h-6 md:w-6" data-id="element-191" />
        </button>

        {/* Slide Counter */}
        <div className="absolute top-4 right-4 bg-black/60 text-white text-sm font-medium px-3 py-1 rounded-full" data-id="element-192">
          {currentIndex + 1} / {images.length}
        </div>
      </div>

      {/* Dot Indicators */}
      <div className="flex justify-center gap-2 mt-4 flex-wrap" data-id="element-193">
        {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`h-2.5 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 ${index === currentIndex ? 'bg-blue-900 w-8' : 'bg-gray-300 hover:bg-gray-400 w-2.5'}`} aria-label={`Aller à la page ${index + 1}`} aria-current={index === currentIndex ? 'true' : 'false'} data-id="element-194" />)}
      </div>
    </div>;
}